import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";

export default function ThankYouPage() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "linear-gradient(135deg, #111 0%, #1e1209 60%, #2d1a08 100%)" }}
    >
      <div
        className="max-w-md w-full rounded-2xl p-8 sm:p-10 text-center"
        style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,122,0,0.25)" }}
      >
        <div
          className="w-16 h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center"
          style={{ background: "rgba(34,197,94,0.15)" }}
        >
          <CheckCircle size={36} weight="fill" className="text-green-500" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-black text-white tracking-tight mb-3">
          Thank you!
        </h1>
        <p className="text-neutral-400 text-sm sm:text-base leading-relaxed mb-8">
          Your requirement has been submitted successfully. Our team will verify and connect you with the best suppliers in your area.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold text-white transition-opacity hover:opacity-90"
            style={{ background: "#FF7A00" }}
          >
            Back to home
            <ArrowRight size={16} weight="bold" />
          </Link>
          <Link
            to="/materials"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold transition-opacity hover:opacity-90"
            style={{ background: "rgba(255,255,255,0.08)", color: "#fff", border: "1px solid rgba(255,255,255,0.15)" }}
          >
            Submit another
          </Link>
        </div>
      </div>
    </div>
  );
}
